<div class="flex flex-row">
  <!-- LOGO -->
  <div class="flex-initial">
    <img src="../../../../../assets/hypecast-logo.png" class="h-7 w-7" alt="Hypecast" />
  </div>
</div>
